<lib-generic-dropdown-multiselect
    [source]="source"
    [(selectedItems)]="selectedItems"
    (selectedItemsChange)="onSelectedItemChange()"
    [config]="{
        multiple: true,
        defaultText: 'Select ' + label,
        itemDisplayKey: additionalInfo?.itemDisplayKey ?? 'name',
        itemTemplate: customItemTemplate
    }"
    [isReadOnly]="isReadOnly"
    [error]="!isValid"
>
</lib-generic-dropdown-multiselect>
<ng-template #customItemTemplate let-data>
    <app-custom-menu-item
        [inputText]="data.inputText"
        [title]="data.object.name"
        [titlePrefix]="!data.object.isActive ? { text: 'Archived', textColor: 'danger' } : undefined"
    >
    </app-custom-menu-item>
</ng-template>
<app-validation-error-message [show]="!isValid" [errors]="validationErrors"></app-validation-error-message>
